import React from "react";
import PropTypes from "prop-types";

import { useVideoDataContext } from "../contexts/VideoDataContext";
import { YoutubePlayer } from "./YoutubePlayer";
import { hasYoutubeTag } from "./YoutubePlayer/utils";

export const OrcaOrYoutube = ({ forwardedRef, Player, ...videoProps }) => {
  const { videoData } = useVideoDataContext();
  const hasYoutubeId = videoData.additional_properties?.youtubeVideoId;
  const renderYoutubePlayer = hasYoutubeTag(videoData) && hasYoutubeId;

  return renderYoutubePlayer ? (
    <YoutubePlayer />
  ) : (
    <Player orcaRef={forwardedRef} {...videoProps} />
  );
};

OrcaOrYoutube.propTypes = {
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  Player: PropTypes.elementType.isRequired
};
